import * as yup from 'yup';

export default ({ middleInitialsMandatory }) => {
  if (middleInitialsMandatory) {
    return {
      middleInitial: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.profile.middle.initials'),
    };
  }
  return {};
};
